import alt, { AltStoreModel } from '../../alt';
import CuratedSetRowActions from '../actions/curated_set_row_actions';
import CuratedSet from '../curated_set';

interface State {
  curated_sets: CuratedSet[];
}

class CuratedSetRowStore extends AltStoreModel<State> implements State {
  curated_sets = [];

  constructor() {
    super();
    this.bindActions(CuratedSetRowActions);
  }

  onSetRow(curated_sets: any[]) {
    this.curated_sets = curated_sets;
  }
}

export default alt.createStore(CuratedSetRowStore, 'CuratedSetRowStore');
